module.exports = __webpack_public_path__ + "img/office-time.a9b77322.svg";